// extracted by mini-css-extract-plugin
export default {"navTabs":"NavTabsContainer_navTabs__AaxZg"};